var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-my-pages-template',{attrs:{"title":_vm.t('addNewCustomerTitle'),"text":_vm.t('addNewCustomerSubTitle'),"with-go-back":true}},[_c('oie-add-edit-machine-owner-form',{on:{"cancel":_vm.goBack,"save":_vm.goBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }